import {getCurrentQuotePdf} from 'v4/utils/quotePdfFiles';

export default function filterFilesForMail(files) {
    if (!files) return [];

    const notIsPdfFiles = files.filter(({quotePdf}) => !quotePdf);

    return [...notIsPdfFiles, getCurrentQuotePdf(files)].filter(Boolean);
}
